import CustomerProfileFilter from './CustomerProfileFilter'

export default CustomerProfileFilter
